export const STATISTICS_SUMMARY_GET = `STATISTICS_SUMMARY_GET`;
export const STATISTICS_SUMMARY_GET_SUCCESS = `STATISTICS_SUMMARY_GET_SUCCESS`;
export const STATISTICS_SUMMARY_GET_FAILURE = `STATISTICS_SUMMARY_GET_FAILURE`;
export const STATISTICS_SUMMARY_GET_REQUEST = `STATISTICS_SUMMARY_GET_REQUEST`;
